module.exports = __webpack_public_path__ + "static/media/formacao_professores_mobile.e9fa34cd.webp";